// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  justify-content: center;
  border-bottom: none;
}

.modal-body {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 1rem 1.5rem;
}

#delete-acc-form {
  width: 100%;
  margin-top: 25px;
}

#delete-acc-pass-label {
  color: grey;
}

#delete-acc-pass {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-delete-modal/account-delete-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,oBAAA;AACJ;;AAEA;EACI,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,WAAA;AACJ","sourcesContent":[".modal-header {\r\n    justify-content: center;\r\n    border-bottom: none;\r\n}\r\n\r\n.modal-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 10px;\r\n    padding: 1rem 1.5rem;\r\n}\r\n\r\n#delete-acc-form {\r\n    width: 100%;\r\n    margin-top: 25px;\r\n}\r\n\r\n#delete-acc-pass-label {\r\n    color: grey;\r\n}\r\n\r\n#delete-acc-pass {\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
